<div class="bg-transparent page-height overflow-auto">
  <app-loading-spinner
    *ngIf="isLoading"
    [text]="'My Bids & Offers'"
  ></app-loading-spinner>
  <div
    class="text-3xl font-medium px-2 flex flex-col items-start justify-start mx-auto max-w-xl"
  >
    My Bids & Offers
  </div>
  <div
    *ngIf="filteredLots$ | async as data"
    class="page-height p-4 flex flex-col items-center justify-start mx-auto max-w-xl"
  >
    <ng-container>
      <!-- search my lot -->
      <div class="flex flex-row justify-stretch items-center gap-4 w-full">
        <mat-form-field appearance="outline" class="mt-4 w-full">
          <mat-label>Search</mat-label>
          <input
            matInput
            (keyup)="searchList($event)"
            placeholder="Ex. Corn or 2024-09-12"
            #input
          />
        </mat-form-field>
        <!-- <span *ngIf="userDetails.market_options.length">
        <mat-form-field
          class="mt-4 w-full"
          appearance="outline"
          *ngIf="userDetails.market_options.length > 1"
        >
          <mat-label>Select Market</mat-label>
          <mat-select
            [value]="selectedMarket"
            (selectionChange)="getLots($event.value)"
          >
            <mat-option
              *ngFor="let option of userDetails.market_options; index as i"
              [value]="option"
            >
              {{ option | uppercase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span> -->
      </div>
      <div class="w-full text-center" *ngIf="!data.length">
        You have no active Bids or Offers
      </div>
      <div class="w-full">
        <div *ngIf="data.length">Active</div>
        <ng-container *ngFor="let item of data">
          <mat-card
            *ngIf="item.status === 'Active'"
            class="lot-item my-card p-4 my-2 w-full"
          >
            <a [routerLink]="['/app/lots', item._id]">
              <div class="flex justify-between items-center">
                <div class="text-lg font-medium text-center align-center">
                  {{ item.commodity }} - {{ item.grade }}
                </div>

                <mat-chip-set class="flex flex-row pl-2 items-start">
                  <fa-icon
                    *ngIf="hasNegotiation()(item._id)"
                    [icon]="faHandShake"
                    size="lg"
                    [style]="{ color: '#ff9500', padding: '5px' }"
                  ></fa-icon>
                  <mat-chip-option
                    aria-label="sent-counter"
                    disableRipple="true"
                    class="text-xs purple-chip p-0"
                    >My
                  </mat-chip-option>
                  <mat-chip-option
                    style="margin-left: 4px !important"
                    class="text-xs"
                    disableRipple="true"
                    [ngClass]="{
                      'blue-chip': item.lot_type === 'Offer',
                      'green-chip': item.lot_type === 'Bid'
                    }"
                  >
                    {{ item.lot_type }}
                  </mat-chip-option>
                  @if(item.indication){
                  <mat-chip class="light-blue-chip">Indication</mat-chip>
                  }
                </mat-chip-set>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-xs align-center font-normal text-wrap">
                  created: {{ item.createdAt | date : "MMM d, y" }}
                </span>
              </div>

              <div class="flex justify-between items-center">
                @if(item.ship_begin.split('-')[0] ==
                item.ship_end.split('-')[0]){
                <div class="text-sm">
                  {{ item.ship_begin | date : "MMM d" }} -
                  {{ item.ship_end | date : "MMM d, y" }}
                </div>
                } @else {
                <div class="text-sm">
                  {{ item.ship_begin | date : "MMM d, y" }} -
                  {{ item.ship_end | date : "MMM d, y" }}
                </div>
                }
                <div class="text-sm font-medium">
                  {{ item.volume_value }}
                  {{ item.units === "Metric Tonnes" ? "MT" : item.units }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-sm">
                  {{ item.destination }} ({{ item.delivery_type }})
                </div>
                <div class="text-sm font-medium">
                  {{ item.currency }} ${{ item.price | priceType }} /
                  {{ item.units === "Metric Tonnes" ? "MT" : item.units }}
                </div>
              </div>
            </a>
          </mat-card>
        </ng-container>
        <hr class="my-6 w-full text-center" />
        <div *ngIf="data.length">Inactive</div>
        <ng-container *ngFor="let item of data">
          <mat-card
            *ngIf="item.status !== 'Active'"
            class="lot-item my-card p-4 my-2 w-full"
          >
            <a [routerLink]="['/app/lots', item._id]">
              <div class="flex justify-between items-center">
                <div class="text-lg font-medium text-wrap">
                  {{ item.commodity }} - {{ item.grade }}
                  <!-- <span class="text-xs align-center font-normal">
                    - created: {{ item.createdAt | date : "MMM d, y" }}</span
                  > -->
                </div>
                <mat-chip-set
                  class="flex flex-row items-start justify-center gap-0"
                >
                  <mat-chip
                    *ngIf="item.status === 'Accepted'"
                    class="green-chip text-xs"
                  >
                    Accepted
                  </mat-chip>
                  <mat-chip
                    *ngIf="item.status === 'Expired'"
                    class="grey-chip text-xs"
                  >
                    Expired
                  </mat-chip>
                  <mat-chip
                    *ngIf="item.status === 'Cancelled'"
                    class="red-chip text-xs"
                  >
                    Cancelled
                  </mat-chip>
                  <mat-chip-option
                    aria-label="sent-counter"
                    disableRipple="true"
                    class="text-xs purple-chip p-0"
                    >My
                  </mat-chip-option>
                  <mat-chip-option
                    class="text-xs p-0"
                    disableRipple="true"
                    [ngClass]="{
                      'blue-chip': item.lot_type === 'Offer',
                      'green-chip': item.lot_type === 'Bid'
                    }"
                  >
                    {{ item.lot_type }}
                  </mat-chip-option>
                  @if(item.indication){
                  <mat-chip class="light-blue-chip">Indication</mat-chip>
                  }
                </mat-chip-set>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-xs align-center font-normal text-wrap">
                  created: {{ item.createdAt | date : "MMM d, y" }}
                </span>
              </div>
              <div class="flex justify-between items-center">
                @if(item.ship_begin.split('-')[0] ==
                item.ship_end.split('-')[0]){
                <div class="text-sm">
                  {{ item.ship_begin | date : "MMM d" }} -
                  {{ item.ship_end | date : "MMM d, y" }}
                </div>
                } @else{
                <div class="text-sm">
                  {{ item.ship_begin | date : "MMM d, y" }} -
                  {{ item.ship_end | date : "MMM d, y" }}
                </div>
                }
                <div class="text-sm font-medium">
                  {{ item.volume_value }}
                  {{ item.units === "Metric Tonnes" ? "MT" : item.units }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-sm">
                  {{ item.destination }} ({{ item.delivery_type }})
                </div>
                <div class="text-sm font-medium">
                  {{ item.currency }} ${{ item.price | priceType }} /
                  {{ item.units === "Metric Tonnes" ? "MT" : item.units }}
                </div>
              </div>
            </a>
          </mat-card>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
